<template>
    <v-card :loading="loading" min-height="500" flat mx-2>
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-container class="px-10" fluid v-if="!loading">
            <form autocomplete="off">
                <v-row>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Detalii oferta</v-card-title>
                            <v-card-text>
                                <v-combobox
                                    :items="emailSuggestions"
                                    v-model="form.data.email"
                                    :search-input.sync="form.data.email"
                                    :error-messages="errorMessages('data.email')"
                                    :class="{ 'error--text': hasErrors('data.email') }"
                                    class="primary--text"
                                    name="data.email"
                                    label="E-mail"
                                    data-vv-as="E-mail"
                                    data-vv-name="data.email"
                                    :autocomplete="`autocomplete_off_${strRandom(10)}`"
                                />
                                <v-combobox
                                    :items="phoneSuggestions"
                                    v-model="form.data.phone"
                                    :search-input.sync="form.data.phone"
                                    :error-messages="errorMessages('data.phone')"
                                    :class="{ 'error--text': hasErrors('data.phone') }"
                                    class="primary--text"
                                    name="data.phone"
                                    label="Telefon"
                                    data-vv-as="Telefon"
                                    data-vv-name="data.phone"
                                    :autocomplete="`autocomplete_off_${strRandom(10)}`"
                                />
                                <v-text-field
                                    v-model="form.data.contact_person"
                                    :error-messages="errorMessages('data.contact_person')"
                                    :class="{ 'error--text': hasErrors('data.contact_person') }"
                                    class="primary--text"
                                    name="data.contact_person"
                                    label="Persoana de contact"
                                    data-vv-as="Persoana de contact"
                                    data-vv-name="data.contact_person"
                                />
                                <v-textarea
                                    v-model="form.data.remarks"
                                    :error-messages="errorMessages('data.remarks')"
                                    :class="{ 'error--text': hasErrors('data.remarks') }"
                                    class="primary--text"
                                    name="data.remarks"
                                    label="Observatii interne"
                                    data-vv-as="Observatii interne"
                                    data-vv-name="data.remarks"
                                />
                                <v-textarea
                                    v-model="form.data.client_remarks"
                                    :error-messages="errorMessages('data.client_remarks')"
                                    :class="{ 'error--text': hasErrors('data.client_remarks') }"
                                    class="primary--text"
                                    name="data.client_remarks"
                                    label="Observatii client"
                                    data-vv-as="Observatii client"
                                    data-vv-name="data.client_remarks"
                                />
                                <v-combobox
                                    :items="delegates"
                                    item-text="delegate_name"
                                    item-value="delegate_name"
                                    v-model="form.data.delegate_name"
                                    :error-messages="errorMessages('data.delegate_name')"
                                    :class="{ 'error--text': hasErrors('data.delegate_name') }"
                                    class="primary--text"
                                    name="data.delegate_name"
                                    label="Numele delegatului"
                                    data-vv-as="Numele delegatului"
                                    data-vv-name="data.delegate_name"
                                    :return-object="false"
                                    @change="changeDelegate"
                                />
                                <v-text-field
                                    v-model="form.data.delegate_id"
                                    :error-messages="errorMessages('data.delegate_id')"
                                    :class="{ 'error--text': hasErrors('data.delegate_id') }"
                                    class="primary--text"
                                    name="data.delegate_id"
                                    label="CI delegat"
                                    data-vv-as="CI delegat"
                                    data-vv-name="data.delegate_id"
                                />
                                <v-text-field
                                    v-model="form.data.delegate_id_emission"
                                    :error-messages="errorMessages('data.delegate_id_emission')"
                                    :class="{ 'error--text': hasErrors('data.delegate_id_emission') }"
                                    class="primary--text"
                                    name="data.delegate_id_emission"
                                    label="Emitent CI delegat"
                                    data-vv-as="Emitent CI delegat"
                                    data-vv-name="data.delegate_id_emission"
                                />
                                <v-text-field
                                    v-model="form.data.delegate_via"
                                    :error-messages="errorMessages('data.delegate_via')"
                                    :class="{ 'error--text': hasErrors('data.delegate_via') }"
                                    class="primary--text"
                                    name="data.delegate_via"
                                    label="Mijloc de transport"
                                    data-vv-as="Mijloc de transport"
                                    data-vv-name="data.delegate_via"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Detalii client</v-card-title>
                            <v-card-text>
                                <customer-modal
                                    v-model="form.customer_id"
                                    :field-errors="errorMessages('customer_id')"
                                    :initial-items="[form.customer]"
                                    @change="(customer) => form.customer = customer"
                                    :expandeable="true"
                                    :show-orders-summary="_.isNil(form.id)"
                                    show-summary
                                />
                            </v-card-text>
                        </v-card>
                        <v-card elevation="2" class="mt-3">
                            <v-card-text>
                                <v-checkbox v-model="form.data.isCurrency">
                                    <template v-slot:label>
                                        Convertor valuta in RON
                                    </template>
                                </v-checkbox>
                                <template v-if="form.data.isCurrency">
                                    <v-select
                                        :items="(new $db.Offer).currencies"
                                        label="Valuta"
                                        v-model="form.data.currency"
                                    />
                                    <v-text-field
                                        label="Curs valutar"
                                        v-model="form.data.currencyExchange"
                                        type="number"
                                    >
                                        <template v-slot:append-outer>
                                            <v-btn
                                                :disabled="!canEdit || parseFloat(form.data.currencyExchange) < 0"
                                                color="error"
                                                outlined
                                                x-small
                                                fab
                                                @click="convertPrices"
                                            >
                                                <v-icon>mdi-arrow-right-thick</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-text-field>
                                    <v-alert
                                        dense
                                        outlined
                                        type="info"
                                    >
                                        Dupa actualizarea cursului valutar, apasati butonul "&#8594" pentru a actualiza lista de produse.
                                    </v-alert>
                                </template>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Detalii echipament</v-card-title>
                            <v-card-text>
                                <equipment-modal
                                    v-model="form.equipment_id"
                                    :field-errors="errorMessages('equipment_id')"
                                    :initial-items="[form.equipment]"
                                    :customer-id="form.customer_id"
                                    :autocomplete="true"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Actiuni oferta</v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <template v-if="!_.isNil(form.id)">
                                                <v-subheader>Ofertare si facturare</v-subheader>
                                                <v-btn
                                                    v-if="!_.isNil(form.id)"
                                                    block
                                                    color="info"
                                                    class="my-2"
                                                    @click="downloadOffer"
                                                >
                                                    Generare Oferta
                                                </v-btn>
                                                <v-btn
                                                    v-if="!_.isNil(form.id)"
                                                    :disabled="_.isNil(form.proforma_no) && !isDocumentOwner"
                                                    block
                                                    :color="!_.isNil(form.proforma_no) ? 'warning' : 'primary'"
                                                    class="my-2"
                                                    @click="downloadProforma"
                                                >
                                                    {{ !_.isNil(form.proforma_no) ? `Proforma ${form.full_proforma_number}` : `Generare Proforma` }}
                                                </v-btn>
                                                <v-btn
                                                    v-if="!_.isNil(form.id) && form.services_count > 0"
                                                    :disabled="_.isNil(form.eow_no) && !isDocumentOwner"
                                                    block
                                                    :color="!_.isNil(form.eow_no) ? 'warning' : 'primary'"
                                                    class="my-2"
                                                    @click="downloadEstimateOfWork"
                                                >
                                                    {{ !_.isNil(form.eow_no) ? `Deviz ${form.full_estimate_of_work_number}` : `Generare Deviz` }}
                                                </v-btn>
                                                <v-btn
                                                    v-if="canGenerateInvoice"
                                                    :disabled="_.isNil(form.invoice) && !isDocumentOwner"
                                                    block
                                                    :color="!_.isNil(form.invoice) ? 'warning' : 'success'"
                                                    class="my-2"
                                                    @click="downloadFiscalInvoice"
                                                >
                                                    {{ !_.isNil(form.invoice) ? `Factura ${form.invoice_number}` : `Generare Factura Fiscala` }}
                                                </v-btn>
                                                <v-btn
                                                    v-if="!_.isNil(form.invoice)"
                                                    :disabled="_.isNil(form.invoice.recipe) && !isDocumentOwner"
                                                    block
                                                    :color="!_.isNil(form.invoice.recipe) ? 'warning' : 'success'"
                                                    class="my-2"
                                                    @click="downloadFiscalInvoiceRecipe"
                                                >
                                                    {{ !_.isNil(form.invoice.recipe) ? `Chitanta ${form.invoice.recipe.recipe_number}` : `Generare Chitanta` }}
                                                </v-btn>

                                                <template v-if="hasRole('admin')">
                                                    <v-checkbox v-model="exportOptions.includeEntryPrice" hide-details>
                                                        <template v-slot:label>
                                                            Afisare pret achizitie
                                                            <v-tooltip right>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon
                                                                        color="warning"
                                                                        dark
                                                                        small
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>Cu exceptia facturilor si chitantelor fiscale</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </template>

                                                <v-checkbox v-model="exportOptions.includeDelivery" hide-details>
                                                    <template v-slot:label>
                                                        Afisare termen de livrare
                                                        <v-tooltip right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                    color="warning"
                                                                    dark
                                                                    small
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    mdi-information
                                                                </v-icon>
                                                            </template>
                                                            <span>Cu exceptia facturilor si chitantelor fiscale</span>
                                                        </v-tooltip>
                                                    </template>
                                                </v-checkbox>

                                                <v-divider class="my-4"></v-divider>
                                            </template>


                                            <v-subheader>Schimbare stare</v-subheader>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && canEdit && form.status !== 'PENDING_CUSTOMER'"
                                                :disabled="!isDocumentOwner"
                                                block
                                                color="warning"
                                                class="my-2"
                                                @click="setStatus('PENDING_CUSTOMER')"
                                            >
                                                Status: In asteptare
                                            </v-btn>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && canEdit"
                                                :disabled="!isDocumentOwner"
                                                block
                                                color="error"
                                                class="my-2"
                                                @click="setStatus('CANCELED')"
                                            >
                                                Status: Anulat
                                            </v-btn>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && hasRole('admin')"
                                                block
                                                color="success"
                                                class="my-2"
                                                @click="setStatus('INVOICED')"
                                            >
                                                Status: Facturat
                                            </v-btn>

                                            <v-subheader>Actiuni</v-subheader>
                                            <v-btn
                                                v-if="canEdit"
                                                :loading="form.busy"
                                                :disabled="errors.any() || form.busy"
                                                block
                                                color="success"
                                                class="my-2"
                                                @click="submit()"
                                            >
                                                <v-icon left>
                                                    save
                                                </v-icon>
                                                Salveaza
                                            </v-btn>
                                            <template v-if="!_.isNil(form.id)">
                                                <customer-feedback-dialog
                                                    :customer-id="form.customer_id"
                                                    subject-type="App\Models\Offer\Offer"
                                                    :subject-id="form.id"
                                                    :disabled="!isDocumentOwner"
                                                    classes="mt-2"/>
                                                <customer-notification-dialog
                                                    :customer-id="form.customer_id"
                                                    subject-type="App\Models\Offer\Offer"
                                                    :subject-id="form.id"
                                                    :attachments="(new $db.Offer(form)).availableAttachments"
                                                    :disabled="!isDocumentOwner"
                                                    classes="mt-2"/>
                                            </template>
                                        </v-col>
                                        <v-col v-if="showProfitabilityGauge" align-self="center">
                                            <vue-gauge :options="profitabilityGaugeOptions"></vue-gauge>
                                            <p class="text-center">Profitabilitate: {{ parseFloat(this.profitabilityGaugeOptions.needleValue).toFixed(0) }}%</p>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card elevation="2">
                            <v-card-title>Produse si servicii</v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead class="offer-thead">
                                        <tr>
                                            <th class="text-left" width="150">
                                                Tip
                                            </th>
                                            <th class="text-left">
                                                Denumire
                                            </th>
                                            <th class="text-left" width="200">
                                                Cod Produs
                                            </th>
                                            <th class="text-left" width="50">
                                                Cantitate
                                            </th>
                                            <th class="text-left" width="50">
                                                UM
                                            </th>
                                            <th v-if="form.data.isCurrency" class="text-left" width="100">
                                                PU ofertat<br/>{{ form.data.currency || 'EUR' }}
                                            </th>
                                            <th class="text-left" width="100">
                                                PU Ofertat<br/>RON
                                            </th>
                                            <th class="text-left" width="100">
                                                PU Ofertat cu TVA<br/>RON
                                            </th>
                                            <th v-if="form.data.isCurrency" class="text-left" width="100">
                                                PU Achiz.<br/>{{ form.data.currency || 'EUR' }}
                                            </th>
                                            <th class="text-left" width="100">
                                                PU Achiz.<br/>RON
                                            </th>
                                            <th class="text-left" width="300">
                                                Furnizor
                                            </th>
                                            <th class="text-left" width="100">
                                                Cost Transp.<br/>RON
                                            </th>
                                            <th class="text-left" width="100">
                                                Termen Livr.<br/>RON
                                            </th>
                                            <th class="text-right" width="50">
                                                <v-btn :disabled="!canEdit" color="success" x-small @click="addProduct(undefined)">Adaugare</v-btn>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody class="offer-tbody">
                                            <v-offer-row
                                                v-for="(product, index) in form.products"
                                                :key="`product-${index}`"
                                                :value="product"
                                                :index="index"
                                                :has-errors="hasErrors"
                                                :error-messages="errorMessages"
                                                :is-currency="form.data.isCurrency"
                                                :can-edit="canEdit"
                                                @input="(val) => form.products[index] = val"
                                                @delete="deleteProduct(index)"
                                            />
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td colspan="3">Total</td>
                                            <td>{{ _.sumBy(form.products, (product) => parseFloat(product.quantity)) | number }}</td>
                                            <td colspan="1"></td>
                                            <td v-if="form.data.isCurrency">
                                                {{ totalCurrencyValue | price({currency: form.data.currency || 'EUR'}) }}
                                            </td>
                                            <td v-else></td>
                                            <td></td>
                                            <td v-if="form.data.isCurrency"></td>
                                            <td v-if="form.data.isCurrency">
                                                {{ totalEntryCurrencyValue | price({currency: form.data.currency || 'EUR'}) }}
                                            </td>
                                            <td>
                                                {{ totalEntryValue | price({currency: 'RON'}) }}
                                            </td>
                                            <td></td>
                                            <td>{{ _.sumBy(form.products, (product) => parseFloat(product.transport_cost)) | price }}</td>
                                            <td>
                                                {{ totalValueWithVat | price({currency: 'RON'}) }}
                                            </td>
                                            <td>
                                                <v-btn :disabled="!canEdit" color="success" x-small @click="addProduct(undefined)">Adaugare</v-btn>
                                            </td>
                                        </tr>
                                        </tfoot>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </form>
        </v-container>
    </v-card>
</template>

<script>
    import CustomerModal from 'Components/modal/CustomerModal'
    import EquipmentModal from 'Components/modal/EquipmentModal'

    import CustomerNotificationDialog from 'Components/modal/CustomerNotificationDialog'
    import CustomerFeedbackDialog from 'Components/modal/CustomerFeedbackDialog'

    import VueGauge from 'vue-gauge';
    import validationError from "Mixins/validation-error";
    import ACL from "Mixins/acl";
    import {Form} from "vform";
    import throttle from 'lodash/throttle'
    import { createNamespacedHelpers } from "vuex";
    const { mapGetters } = createNamespacedHelpers("auth");
    const { mapMutations } = createNamespacedHelpers("temp");

    export default {
        mixins: [validationError, ACL],
        components: {
            CustomerModal,
            EquipmentModal,
            VueGauge,
            CustomerFeedbackDialog,
            CustomerNotificationDialog
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                customer_id: null,
                proforma_no: null,
                proforma_date: null,
                full_proforma_number: null,
                equipment_id: null,
                document_no: null,
                offer_date: null,
                services_count: 0,
                eow_no: null,
                eow_date: null,
                full_estimate_of_work_number: null,
                status: null,
                customer: {
                    summary: {
                        emails: [],
                        phones: [],
                        delegates: []
                    }
                },
                equipment: null,
                products: [],
                created_by: null,
                data: {
                    contact_person: null,
                    email: null,
                    phone: null,
                    delegate_id: null,
                    delegate_via: 'POSTA ELECTRONICA',
                    delegate_name: 'POSTA ELECTRONICA',
                    delegate_id_emission: null,
                    remarks: null,
                    client_remarks: null,
                    isCurrency: false,
                    currency: null,
                    currencyExchange: '1'
                },
                invoice: null
            }),
            showProfitabilityGauge: false,
            profitabilityGaugeOptions: {
                hasNeedle: true,
                needleColor: "black",
                needleStartValue: 50,
                arcColors: ["rgb(255,84,84)", "rgb(239,214,19)", "rgb(61,204,91)"],
                arcDelimiters: [40, 60],
                needleValue: 0,
                chartWidth: 300
            },
            exportOptions: {
                includeDelivery: false,
                includeEntryPrice: false
            }
        }),
        computed: {
            ...mapGetters({
                getMe: "getMe"
            }),
            canEdit() {
                if (this._.isNil(this.form.id)) return true
                if (this.hasRole('admin')) return true
                if (!this._.isNil(this.form.eow_no) || !this._.isNil(this.form.invoice) || (!this._.isNil(this.form.status) && ['CANCELED', 'FINALIZED'].indexOf(this.form.status) >= 0)) return false
                if (!this.isDocumentOwner) return false
                return true
            },
            isDocumentOwner() {
                if (this._.isNil(this.form.id)) return true
                return !this._.isNil(this.form.created_by) && this.getMe?.id === this.form.created_by || this.hasRole('admin')
            },
            canGenerateInvoice() {
                return (!this._.isNil(this.form.proforma_no) && this.form.services_count < 1) ||
                    (this.form.services_count > 0 && !this._.isNil(this.form.eow_no));
            },
            emailSuggestions() {
                return Object.values(this.form.customer?.summary?.emails || {})
            },
            phoneSuggestions() {
                return Object.values(this.form.customer?.summary?.phones || {})
            },
            totalTransportCost() {
                return this._.sumBy(this.form.products, (product) => { return parseFloat(product.transport_cost)})
            },
            totalValueWithVat() {
                return this._.sumBy(this.form.products, (product) => { return parseFloat(product.quantity) * parseFloat(product.unit_price_with_vat)})
            },
            totalValue() {
                return this._.sumBy(this.form.products, (product) => { return parseFloat(product.quantity) * parseFloat(product.unit_price)})
            },
            totalProductsValue() {
                let products = this.form.products.filter(p => p.type === 'PRODUCT')
                return this._.sumBy(products, (product) => { return parseFloat(product.quantity) * parseFloat(product.unit_price)})
            },
            totalEntryValue() {
                return this._.sumBy(this.form.products, (product) => { return parseFloat(product.quantity) * parseFloat(product.entry_amount)})
            },
            totalCurrencyValue() {
                return this._.sumBy(this.form.products, (product) => {
                    let val = parseFloat(product.unit_price_currency) > 0 ? parseFloat(product.unit_price_currency) : 0
                    return parseFloat(product.quantity) * val
                })
            },
            totalEntryCurrencyValue() {
                return this._.sumBy(this.form.products, (product) => {
                    let val = parseFloat(product.entry_amount_currency) > 0 ? parseFloat(product.entry_amount_currency) : 0
                    return parseFloat(product.quantity) * val
                })
            },
            delegates() {
                return this._.get(this.form.customer, 'summary.delegates', [])
            }
        },
        watch: {
            'form.customer': {
                handler(val) {
                    if(val?.id) {
                        this.form.customer_id = val.id
                    }
                },
                deep: true
            },
            'form.equipment': {
                handler(val) {
                    if(val?.id) {
                        this.form.equipment_id = val.id
                    }
                },
                deep: true
            },
            'form.products': {
                handler() {
                    this.showProfitabilityGauge = false
                    var revenue = this.totalProductsValue
                    var cost = (this.totalEntryValue + this.totalTransportCost)
                    var profitabilityGaugeValue = Math.abs((100 - (cost * 100 / revenue)))
                    if (!isFinite(profitabilityGaugeValue)) profitabilityGaugeValue = 100
                    if (profitabilityGaugeValue >= 0) {
                        this.profitabilityGaugeOptions.needleValue = profitabilityGaugeValue.toFixed(0)
                    } else {
                        this.profitabilityGaugeOptions.needleValue = 0
                    }
                    this.$nextTick(() => this.showProfitabilityGauge = true)
                },
                deep: true
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
            if(this.form.products.length < 1) {
                this.addProduct(undefined)
            }
            this.showProfitabilityGauge = true
            switch (this.$route.hash) {
                case '#download-offer':
                    this.downloadOffer()
                    break
            }
        },
        methods: {
            ...mapMutations({
                addSupplier: "addSupplier"
            }),
            loadResource: throttle(async function (val) {
                let self = this;
                this.loading = true;

                let data = await this.$db.Offer
                    .append('full_proforma_number', 'full_estimate_of_work_number', 'invoice_number', 'services_count')
                    .include('customer', 'equipment', 'products.pivot.supplier', 'invoice.recipe')
                    .find(this.id)
                    .then(({data}) => {
                        data.products = data.products.map((product) => {
                            this.addSupplier(product.pivot.supplier)
                            return {
                                id: product.id,
                                type: product.type,
                                name: product.name,
                                product_number: product.product_number,
                                quantity: product.pivot.quantity,
                                measurement: product.pivot.measurement,
                                entry_amount_currency: product.pivot.entry_amount_currency,
                                entry_amount: product.pivot.entry_amount,
                                transport_cost: product.pivot.transport_cost,
                                supplier_id: product.pivot.supplier_id,
                                unit_price: product.pivot.unit_price,
                                unit_price_with_vat: product.pivot.unit_price_with_vat,
                                unit_price_currency: product.pivot.unit_price_currency,
                                delivery_time: product.pivot.delivery_time
                            }
                        })
                        return data
                    })
                self.form = new Form(data)
                this.loading = false
            }, 500),
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Offer(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        self.form.errors.set({})
                        this.showSuccess();
                        if (this._.isNil(model.id) && response?.id) {
                            self.$nextTick(() => self.$router.push({name: "offers-edit", params: {id: response.id}}));
                        }
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            },
            async setStatus(status) {
                this.loading = true
                await axios.post(route('offers.set-status', {
                    workstation: this.form.workstation_id,
                    offerId: this.form.id,
                    status: status
                })).then(async () => {
                    await this.loadResource()
                }).finally(() => {
                    this.loading = false
                })
            },
            addProduct(index) {
                let definition = {
                    id: null,
                    type: null,
                    name: null,
                    product_number: null,
                    quantity: 1,
                    measurement: 'BUC',
                    entry_amount_currency: 0,
                    entry_amount: 0,
                    transport_cost: 0,
                    supplier_id: null,
                    unit_price: 0,
                    unit_price_with_vat: 0,
                    unit_price_currency: 0,
                    delivery_time: 0
                }
                if (index) {
                    this.form.products.splice(index, 0, definition);
                } else {
                    this.form.products.push(definition);
                }
            },
            deleteProduct(index) {
                if(this.form.products.length > 1) {
                    this.form.products.splice(index, 1);
                }
            },
            changeDelegate() {
                var foundIndex = this._.get(this.form.customer, 'summary.delegates', []).findIndex(item => item.delegate_name === this.form.data.delegate_name)
                if (foundIndex >= 0) {
                    var selectedDelegate = this.form.customer.summary.delegates[foundIndex]
                    this.form.data.delegate_id = selectedDelegate.delegate_id
                    this.form.data.delegate_id_emission = selectedDelegate.delegate_id_emission
                    this.form.data.delegate_name = selectedDelegate.delegate_name
                    this.form.data.delegate_via = selectedDelegate.delegate_via
                }
            },
            async downloadOffer() {
                const downloadEndpoint = new this.$db.Offer({id: this.form.id}).downloadEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint, this.exportOptions)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            },
            async downloadProforma() {
                const downloadEndpoint = new this.$db.Offer({id: this.form.id}).downloadProformaEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint, this.exportOptions)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            },
            async downloadEstimateOfWork() {
                const downloadEndpoint = new this.$db.Offer({id: this.form.id}).downloadEstimateOfWork
                this.loading = true
                await this.downloadFile(downloadEndpoint, this.exportOptions)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            },
            async downloadFiscalInvoice() {
                let downloadEndpoint = new this.$db.Offer({id: this.form.id}).downloadFiscalInvoiceEndpoint
                if (this.hasRole('admin') && !this._.isNil(this.form.invoice)) {
                    if (confirm('Fortati regenerarea documentului?')) {
                        downloadEndpoint += '?force=true'
                    }
                } else if (this._.isNil(this.form.invoice)) {
                    if (!confirm('Confirmati generarea documentului?')) {
                        return
                    }
                }
                this.loading = true
                await this.downloadFile(downloadEndpoint, this.exportOptions)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            },
            async downloadFiscalInvoiceRecipe() {
                let downloadEndpoint = new this.$db.Offer({id: this.form.id}).downloadFiscalInvoiceRecipeEndpoint
                if (this._.isNil(this.form.invoice.recipe)) {
                    if (!confirm('Confirmati generarea documentului?')) {
                        return
                    }
                }
                if (this.hasRole('admin') && !this._.isNil(this.form.invoice.recipe)) {
                    if (confirm('Fortati regenerarea documentului?')) {
                        downloadEndpoint += '?force=true'
                    }
                }
                this.loading = true
                await this.downloadFile(downloadEndpoint)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            },
            convertPrices() {
                this.loading = true;
                if (parseFloat(this.form.data.currencyExchange) < 1) return true
                this.form.products.forEach((item, index) => {
                    if (item.entry_amount_currency) {
                        this.form.products[index].entry_amount = (parseFloat(item.entry_amount_currency) * parseFloat(this.form.data.currencyExchange)).toFixed(2)
                    }
                    if (item.unit_price_currency) {
                        this.form.products[index].unit_price = (parseFloat(item.unit_price_currency) * parseFloat(this.form.data.currencyExchange)).toFixed(2)
                    }
                })
                this.loading = false;
            }
        }
    };
</script>

<style lang="scss">
    .vue-gauge-item {
        text-align: center !important;
    }
    .offer-tbody {
        tr {
            td {
                padding: 0 5px !important;
                .v-text-field__details {
                    display: none !important;
                    &.show {
                        display: block !important;
                    }
                }
            }
        }
    }
    .offer-thead {
        tr {
            th {
                position: sticky;
                top: 0;
            }
        }
    }
</style>
